var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1429_13802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88102 15.275C6.64164 19.0356 12.7329 19.0356 16.4935 15.275L13.5098 13.0406C12.9666 12.635 12.231 12.6281 11.681 13.02L10.0723 14.1681C9.57039 14.5256 8.88289 14.4706 8.44289 14.0306L4.11852 9.70625C3.68539 9.27312 3.62352 8.58562 3.98102 8.07687L5.13602 6.475C5.52789 5.925 5.52102 5.1825 5.11539 4.64625L2.88102 1.6625C-0.879609 5.42312 -0.879609 11.5144 2.88102 15.275Z",
    fill: "#7363F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 8.46875C13.4688 8.46875 10.1481 8.46875 9.6875 8.46875V4.6875C10.6981 4.6875 11.6469 5.07938 12.3619 5.79438C13.0769 6.50938 13.4688 7.45812 13.4688 8.46875Z",
    fill: "#7363F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5938 8.46875H15.5312C15.5312 6.90812 14.9262 5.44375 13.8194 4.33687C12.7125 3.23 11.2481 2.625 9.6875 2.625V0.5625C11.7981 0.5625 13.785 1.3875 15.2769 2.87937C16.7687 4.37125 17.5938 6.35813 17.5938 8.46875Z",
    fill: "#7363F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1429_13802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5312,
    height: 17.5312,
    fill: "white",
    transform: "translate(0.0625 0.5625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.9fc5b08d8b466a5a4baa983cd5c27f23.svg";
export { ForwardRef as ReactComponent };